import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { Event } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface EventsParams {
  skip?: number
  limit?: number
  includeInvited?: boolean
  includeCreated?: boolean
  includeOpen?: boolean
}

export const useEvents = ({
  skip = 0,
  limit = 100,
  includeInvited = true,
  includeCreated = true,
  includeOpen = true,
}: EventsParams = {}) => {
  const fetchWithAuth = useFetchWithAuth()
  const getEvents: QueryFunction<Event[]> = async () => {
    const params = new URLSearchParams({
      skip: skip.toString(),
      limit: limit.toString(),
      include_invited: includeInvited.toString(),
      include_created: includeCreated.toString(),
      include_open: includeOpen.toString(),
    })

    const response = await fetchWithAuth(`${URL}/events?${params.toString()}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })
    return response
  }

  return useQuery({
    queryKey: [
      'events',
      skip,
      limit,
      includeInvited,
      includeCreated,
      includeOpen,
    ] as const,
    queryFn: getEvents,
    retry: false,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}
